import Link from "next/link";
import Image from "next/image";

export type SocialPlatform = "facebook" | "linkedin" | "twitter";

type SocialLinkProps = {
  platform: SocialPlatform;
  src: string;
  alt: string;
  iconClassName?: string;
  shareUrl: string;
};

function SocialLink({ platform, src, alt, iconClassName = "", shareUrl }: SocialLinkProps) {
  const encodedUrl = encodeURIComponent(shareUrl);
  let finalHref = "";

  switch (platform) {
    case "facebook":
      finalHref = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      break;
    case "linkedin":
      finalHref = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`;
      break;
    case "twitter":
      finalHref = `https://twitter.com/intent/tweet?url=${encodedUrl}`;
      break;
    default:
      finalHref = shareUrl;
      break;
  }

  return (
    <Link
      href={finalHref}
      target="_blank"
      rel="noopener noreferrer"
      className="self-center"
    >
      <Image
        width={18}
        height={15}
        src={src}
        alt={alt}
        className={`filter brightness-50 saturate-0 ${iconClassName}`}
      />
    </Link>
  );
}

export type ShareLinksProps = {
  shareUrl: string;
  links?: {
    platform: SocialPlatform;
    src: string;
    alt: string;
    iconClassName?: string;
  }[];
  containerClassName?: string;
  textClassName?: string;
  label?: string;
};

export function ShareSocialMedia({
  shareUrl,
  links = [
    { platform: "facebook", src: "/images/icons/facebook.svg", alt: "Facebook" },
    { platform: "linkedin", src: "/images/icons/linkedin.svg", alt: "LinkedIn" },
    { platform: "twitter", src: "/images/icons/X.svg", alt: "Twitter" },
  ],
  containerClassName = "flex gap-2 items-center text-gray03",
  textClassName = "text-sm text-dark02 uppercase font-bold",
  label = "compartir en",
}: ShareLinksProps) {
  return (
    <div className={containerClassName}>
      <p className={textClassName}>{label}</p>
      {links.map((link, index) => (
        <SocialLink key={index} {...link} shareUrl={shareUrl} />
      ))}
    </div>
  );
}
